import { IMongoDocument } from "@/types"

export enum CARD_SKIN_TYPES {
  ORIGINAL = "original",
  GRAY = "gray",
  DARK = "dark",
  GREEN = "green",
  GOLD = "gold",
  ANTIQUE = "antique",
  SEA = "sea",
  STEAMPUNK = "steampunk",
  CYBERPUNK = "cyberpunk"
}

export interface ICardBackPresence {
  [key: string]: number
}

export interface ICardBack extends IMongoDocument {
  backImgSrc: string
  colorBg: string
  colorBgShadow: string
  colorDescription: string
  colorTitle: string
  exampleImgSrc: string
  frontImgSrc: string
  type: CARD_SKIN_TYPES
}

export interface ICardBackActive extends IMongoDocument {
  player: string
  cardBack: ICardBack
  isActive: boolean
}
